import { Text, Tooltip } from 'ui/baseComponents'
import { UserStatusToggle } from '../UserRow/UserStatusToggle'
import { UserTypeSwitch } from '../UserRow/UserTypeSwitch'
import { isToday, formatDateTime, formatRelativeTime } from 'utilities/time'
import { TABLE_STATUS, TEXT_FIELD_VARIANT } from '../consts'

const SHARED_CELL_STYLES = {
  style: {
    verticalAlign: 'middle',
  },
}
const USER_OBJECT_COLUMN_INDEX = 0

export const getFormattedStatus = (user) => {
  const { status } = user
  const formatDate = (time) =>
    isToday(time) ? formatRelativeTime(time) : formatDateTime(time, 'l')
  const formatDisplayName = (prefix, statusObj) =>
    statusObj?.user?.displayName
      ? [prefix, statusObj.user.displayName].join('')
      : ''

  let formattedStatus = ''
  let formattedDate = ''
  let formattedDisplayName = ''
  let statusPrefix = ''

  // Switch for status tooltip text
  switch (status?.displayName) {
    case TABLE_STATUS.active:
      formattedStatus = 'Active'
      statusPrefix = 'Joined'
      formattedDate = formatDate(status.joinedAt)
      formattedDisplayName = formatDisplayName(
        ', invited by ',
        status.invitedBy,
      )
      break
    case TABLE_STATUS.invited:
      formattedStatus = statusPrefix = 'Invited'
      formattedDate = formatDate(status.invitedAt)
      formattedDisplayName = formatDisplayName(' by ', status.invitedBy)
      break
    case TABLE_STATUS.disabled:
      formattedStatus = statusPrefix = 'Disabled'
      formattedDate = formatDate(status.disabledAt)
      formattedDisplayName = formatDisplayName(' by ', status.disabledBy)
      break
    default:
      break
  }

  const tooltipText = `${statusPrefix} ${
    formattedDate || 'on unknown date'
  }${formattedDisplayName}`

  return { formattedStatus, tooltipText }
}

export const columns = [
  {
    name: 'user',
    label: 'User',
    options: {
      display: false, // Hide this column from the UI
    },
  },
  {
    name: 'email',
    label: 'Email',
    options: {
      sort: true,
      customBodyRender: (value) => {
        return (
          <div>
            <Text variant={TEXT_FIELD_VARIANT}>{value}</Text>
          </div>
        )
      },
      setCellProps: () => SHARED_CELL_STYLES,
    },
  },
  {
    name: 'displayName',
    label: 'Name',
    options: {
      sort: true,
      customBodyRender: (value) => {
        return (
          <div>
            <Text variant={TEXT_FIELD_VARIANT}>{value}</Text>
          </div>
        )
      },
      setCellProps: () => SHARED_CELL_STYLES,
    },
  },
  {
    name: 'status',
    label: 'Status',
    options: {
      customBodyRender: (_, tableMeta) => {
        const user = tableMeta?.rowData[USER_OBJECT_COLUMN_INDEX]

        if (!user) return null
        const { formattedStatus, tooltipText } = getFormattedStatus(user)

        return (
          <Tooltip title={tooltipText}>
            <Text variant={TEXT_FIELD_VARIANT}>{formattedStatus}</Text>
          </Tooltip>
        )
      },
      setCellProps: () => SHARED_CELL_STYLES,
    },
  },
  {
    name: 'role',
    label: 'Role',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (_, tableMeta) => {
        const user = tableMeta?.rowData[USER_OBJECT_COLUMN_INDEX]
        return <UserTypeSwitch {...user} />
      },
      setCellProps: () => SHARED_CELL_STYLES,
    },
  },
  {
    name: 'actions',
    label: 'Actions',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_, tableMeta) => {
        const user = tableMeta?.rowData[USER_OBJECT_COLUMN_INDEX]
        return <UserStatusToggle {...user} />
      },
      setCellProps: () => SHARED_CELL_STYLES,
    },
  },
]
